import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiHome, FiHeart, FiShoppingBag, FiUser } from 'react-icons/fi';
import { useTelegram } from '../../hooks/useTelegram';
import { useCart } from '../../context/CartContext';

const Bar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(10,10,15,0.92);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 0.5px solid rgba(255,255,255,0.06);
  z-index: 100;
  padding-bottom: env(safe-area-inset-bottom, 0px);
`;

const Tabs = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 440px;
  margin: 0 auto;
  padding: 6px 0 4px;
`;

const Tab = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 4px 12px 4px;
  color: ${p => p.$active ? '#006FFF' : 'rgba(255,255,255,0.35)'};
  transition: color 0.2s;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 2px;
    border-radius: 1px;
    background: ${p => p.$active ? '#006FFF' : 'transparent'};
    transition: background 0.2s;
  }
`;

const Label = styled.span`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.2px;
`;

const IconWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BadgeCount = styled.div`
  position: absolute;
  top: -6px;
  right: -10px;
  background: #ff3b30;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
`;

const TABS = [
  { path: '/', icon: FiHome, label: 'Главная', exact: true },
  { path: '/favorites', icon: FiHeart, label: 'Избранное' },
  { path: '/cart', icon: FiShoppingBag, label: 'Корзина', badge: true },
  { path: '/profile', icon: FiUser, label: 'Профиль' },
];

const BottomTabBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hapticFeedback } = useTelegram();
  const { count } = useCart();

  if (location.pathname.startsWith('/game/')) return null;

  return (
    <Bar>
      <Tabs>
        {TABS.map(tab => {
          const Icon = tab.icon;
          const active = tab.exact ? location.pathname === tab.path : location.pathname.startsWith(tab.path);
          return (
            <Tab key={tab.path} $active={active} onClick={() => { hapticFeedback?.('light'); navigate(tab.path); }}>
              <IconWrap>
                <Icon size={20} strokeWidth={active ? 2.5 : 1.8} />
                {tab.badge && count > 0 && <BadgeCount>{count > 9 ? '9+' : count}</BadgeCount>}
              </IconWrap>
              <Label>{tab.label}</Label>
            </Tab>
          );
        })}
      </Tabs>
    </Bar>
  );
};

export default BottomTabBar;
